<template>
  <div class="rise-in max-w-2xl mx-auto">
    <div class="card card-pad">
      <div class="flex items-center gap-3 mb-2">
        <span
          class="w-11 h-11 rounded-2xl bg-brand-50 text-brand-600 flex items-center justify-center text-lg"
        >
          <font-awesome-icon icon="cog" />
        </span>
        <h1 class="page-title">Settings</h1>
      </div>
      <p class="text-ink-soft leading-relaxed mb-6">
        Manage your account settings. Update your password below.
      </p>

      <!-- Success state -->
      <div
        v-if="success"
        class="flex items-start gap-3 p-4 rounded-xl bg-green-50 border border-green-100 mb-6"
      >
        <font-awesome-icon
          icon="check-circle"
          class="text-green-600 mt-0.5 flex-shrink-0"
        />
        <div>
          <p class="font-semibold text-ink">Password updated successfully.</p>
          <p class="text-sm text-ink-soft">
            Your new password has been saved.
          </p>
        </div>
      </div>

      <!-- Change password form.
           :key remounts the form after a successful save so the just-cleared
           fields come back pristine — otherwise emptying them re-triggers the
           required/min validation and the errors flash under the success note. -->
      <FormulateForm
        :key="formKey"
        class="space-y-4"
        @submit="onUpdatePassword"
      >
        <FormulateInput
          v-model="password"
          type="password"
          name="password"
          label="New Password"
          validation="required|min:8"
          :validation-messages="{
            min: 'Password must be at least 8 characters.',
          }"
          placeholder="New Password (min 8 characters)"
        />
        <FormulateInput
          v-model="password_confirm"
          type="password"
          name="password_confirm"
          label="Confirm New Password"
          validation="required|confirm:password"
          :validation-messages="{ confirm: 'Passwords do not match.' }"
          placeholder="Confirm New Password"
        />
        <FormulateInput
          type="submit"
          :label="loading ? 'Updating…' : 'Update password'"
          :disabled="loading"
        />
      </FormulateForm>

      <p v-if="error" class="text-red-600 text-sm mt-3">{{ error }}</p>
    </div>
  </div>
</template>

<script>
import { auth } from 'helpers/api'
import { actionTypes } from 'store/auth'

export default {
  name: 'Settings',
  data() {
    return {
      password: '',
      password_confirm: '',
      loading: false,
      success: false,
      error: null,
      formKey: 0,
    }
  },
  methods: {
    async onUpdatePassword() {
      this.error = null
      this.success = false
      this.loading = true
      try {
        await auth.updatePassword(this.password)
        // Drop the temporary-password flag (and the welcome banner) now that
        // the user has chosen their own password.
        await this.$store.dispatch(actionTypes.clearMustChangePassword)
        this.success = true
        this.password = ''
        this.password_confirm = ''
        this.formKey += 1 // remount the form so cleared fields come back pristine
      } catch (e) {
        this.error =
          (e.response &&
            e.response.data &&
            (e.response.data.error ||
              e.response.data.message ||
              e.response.data.error_description)) ||
          e.message ||
          'Could not update password. Please try again.'
      } finally {
        this.loading = false
      }
    },
  },
}
</script>
